import { published } from "../data/published";

export const PublishedJournal = () => {
    return (
        <div className="container">
            <h3>OUR LATEST PUBLISHED JOURNALS</h3>
            <p className="lead">
                Research Discourse: An International Peer-Reviewed Refereed Research Journal, ISSN 2277-2014(Print)
            </p>
            <hr className="custom-line bg-warning" />
            <div className="row">
                {published.map((element, index) => {
                    return (
                        <div key={index} className="col-md-4 mb-3">
                            <div className="card shadow rounded overflow-hidden">
                                <div className="card-header border-0">
                                    <img
                                        src={element.image}
                                        alt="Journal Cover"
                                        className="img-fluid"
                                        style={{ height: "400px", width: "100%" }}
                                    />
                                </div>
                                <div className="card-body">
                                    <h4 className="fw-bold">{element.date}</h4>
                                    <p className="lead">{element.date}</p>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
